import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ToggleDisplay from '../../components/shared/ToggleDisplay';

import config from '../../../config';
import {formatPhoneNumberWithoutBracket} from '../../underwriter/helpers'

const defaultUnderwritersDisplay = (underwriters) => { return underwriters && underwriters.map((uw, idx) => {
    const mailto = `mailto:${uw.email}`;
    return (
        <li className="col-sm-4" key={idx}>
            <strong>
                {uw.firstName} {uw.lastName} &#8211; {uw.position}
            </strong>
            <a href={mailto}>{uw.email}</a>
            <br />
            <span>
            + {uw.phoneExt} {uw.phone}
            </span>
        </li>
    );
});
}

class ContactUs extends Component {
    render() {
        let underwriterDisplay = defaultUnderwritersDisplay(this.props.contactUnderWriter);

        const underwriter = this.props.underwriter;
        if (!underwriter.isLoggedUser) {
            const mailto = `mailto:${underwriter.email}`;
            underwriterDisplay = (
                <li className="col-sm-4" key={1}>
                    <strong>
                        {underwriter.name} &#8211; {underwriter.title}
                    </strong>
                    <a href={mailto}>{underwriter.email}</a>
                    <br />
                    <span>
                    {underwriter.phoneExt}{' '}{formatPhoneNumberWithoutBracket(underwriter.phone)}
                    </span>
                </li>)
        }

        return (
            <Row className="contact-us-component">
                {this.props.children}
                <Col>
                    <p className="col-sm-12">
                        <strong>Need to speak with an Underwriter?</strong>
                    </p>
                    <ul className="underwriters-display clearfix">{underwriterDisplay}</ul>
                </Col>
            </Row>
        );
    }
};

const mapStateToProps = state => ({
    underwriter: state.underwriter,
    contactUnderWriter: state.auth.contactUnderWriter
})

export default connect(mapStateToProps)(ContactUs);
